/* =========================================================
   AIVORA CYBERSOL — KNOWLEDGE BASE CHATBOT
   ZIPCHAT-STYLE PRODUCT CARDS
   =========================================================
   - No OpenRouter
   - No API key
   - Uses the public Shopify product JSON endpoint
   - Knowledge base remains the source of truth
   - Product cards are clickable and open the product page
   ========================================================= */

(function () {
  'use strict';

  var chatbot = document.getElementById('aivora-ai-chat');

  if (!chatbot) return;

  var toggleButton = document.getElementById('aivora-ai-chat-toggle');
  var closeButton = document.getElementById('aivora-ai-chat-close');
  var chatWindow = document.getElementById('aivora-ai-chat-window');
  var chatForm = document.getElementById('aivora-ai-chat-form');
  var chatInput = document.getElementById('aivora-ai-chat-input');
  var sendButton = document.getElementById('aivora-ai-chat-send');
  var messages = document.getElementById('aivora-ai-chat-messages');
  var typingIndicator = document.getElementById('aivora-ai-chat-typing');
  var quickButtons = chatbot.querySelectorAll('[data-chat-message]');

  var knowledgeBase = null;

  var KNOWLEDGE_BASE_URL =
    window.AIVORA_KNOWLEDGE_BASE_URL ||
    '/assets/aivora-knowledge-base.json';

  var MAX_PRODUCT_CARDS = 4;

  /* =========================================================
     ZIPCHAT-STYLE CARD STYLES
     ========================================================= */

  var style = document.createElement('style');

  style.textContent = `
    .aivora-ai-chat__product-grid {
      display: flex;
      gap: 10px;
      overflow-x: auto;
      padding: 3px 2px 7px;
      margin: 9px 0 2px;
      scroll-snap-type: x proximity;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: thin;
    }

    .aivora-ai-chat__product-grid::-webkit-scrollbar {
      height: 5px;
    }

    .aivora-ai-chat__product-card {
      flex: 0 0 154px;
      width: 154px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      border: 1px solid #D9E2EA;
      border-radius: 12px;
      background: #FFFFFF;
      color: #0B1F33;
      text-align: left;
      cursor: pointer;
      padding: 0;
      scroll-snap-align: start;
      box-shadow: 0 3px 12px rgba(11,31,51,.06);
      transition:
        transform .18s ease,
        box-shadow .18s ease,
        border-color .18s ease;
    }

    .aivora-ai-chat__product-card:hover,
    .aivora-ai-chat__product-card:focus-visible {
      transform: translateY(-2px);
      border-color: rgba(0,169,214,.45);
      box-shadow: 0 7px 18px rgba(11,31,51,.11);
      outline: none;
    }

    .aivora-ai-chat__product-image-wrap {
      width: 100%;
      height: 132px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      background: #F7FAFC;
      border-bottom: 1px solid #E6EDF2;
    }

    .aivora-ai-chat__product-image {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
    }

    .aivora-ai-chat__product-image-placeholder {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px;
      color: #7B8A99;
      font-size: 11px;
      text-align: center;
    }

    .aivora-ai-chat__product-body {
      padding: 9px 9px 10px;
    }

    .aivora-ai-chat__product-title {
      margin: 0;
      color: #0B1F33;
      font-size: 12px;
      line-height: 1.38;
      font-weight: 600;
    }

    .aivora-ai-chat__product-price {
      margin-top: 7px;
      color: #0B1F33;
      font-size: 13px;
      line-height: 1.2;
      font-weight: 700;
    }

    .aivora-ai-chat__product-link {
      display: block;
      margin-top: 7px;
      color: #00A9D6;
      font-size: 10px;
      font-weight: 600;
    }

    .aivora-ai-chat__response-links {
      display: flex;
      flex-direction: column;
      gap: 7px;
      margin-top: 9px;
    }

    .aivora-ai-chat__response-link,
    .aivora-ai-chat__response-cta {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-height: 38px;
      width: 100%;
      padding: 8px 11px;
      border-radius: 8px;
      border: 1px solid rgba(0,169,214,.25);
      background: #FFFFFF;
      color: #0B1F33;
      text-decoration: none;
      font: inherit;
      font-size: 11px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      transition:
        background-color .18s ease,
        border-color .18s ease,
        transform .18s ease;
    }

    .aivora-ai-chat__response-link:hover,
    .aivora-ai-chat__response-link:focus-visible {
      background: #F3FAFD;
      border-color: rgba(0,169,214,.55);
      outline: none;
    }

    .aivora-ai-chat__response-cta {
      background: #0B1F33;
      border-color: #0B1F33;
      color: #FFFFFF;
    }

    .aivora-ai-chat__response-cta:hover,
    .aivora-ai-chat__response-cta:focus-visible {
      background: #12344F;
      border-color: #12344F;
      transform: translateY(-1px);
      outline: none;
    }

    @media screen and (max-width: 749px) {
      .aivora-ai-chat__product-card {
        flex-basis: 148px;
        width: 148px;
      }

      .aivora-ai-chat__product-image-wrap {
        height: 124px;
      }
    }
  `;

  document.head.appendChild(style);

  /* =========================================================
     HELPERS
     ========================================================= */

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatText(value) {
    var safe = escapeHtml(value);

    safe = safe.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    safe = safe.replace(/(^|\n)- /g, '$1• ');
    safe = safe.replace(/\n/g, '<br>');

    return safe;
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^\w\s:.-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getTokens(value) {
    return normalize(value)
      .split(' ')
      .filter(function (token) {
        return token.length > 1;
      });
  }

  function scrollToBottom() {
    requestAnimationFrame(function () {
      messages.scrollTop = messages.scrollHeight;
    });
  }

  function openUrl(url) {
    if (!url) return;
    window.location.href = url;
  }

  function openExternalUrl(url) {
    if (!url) return;
    window.location.href = url;
  }

  /* =========================================================
     CHAT OPEN / CLOSE
     ========================================================= */

  function openChat() {
    chatbot.classList.add('is-open');

    if (toggleButton) {
      toggleButton.setAttribute('aria-expanded', 'true');
    }

    if (chatWindow) {
      chatWindow.setAttribute('aria-hidden', 'false');
    }

    if (chatInput) {
      setTimeout(function () {
        chatInput.focus();
      }, 80);
    }
  }

  function closeChat() {
    chatbot.classList.remove('is-open');

    if (toggleButton) {
      toggleButton.setAttribute('aria-expanded', 'false');
    }

    if (chatWindow) {
      chatWindow.setAttribute('aria-hidden', 'true');
    }
  }

  if (toggleButton) {
    toggleButton.addEventListener('click', function () {
      if (chatbot.classList.contains('is-open')) {
        closeChat();
      } else {
        openChat();
      }
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', closeChat);
  }

  /* =========================================================
     KNOWLEDGE BASE
     ========================================================= */

  async function loadKnowledgeBase() {
    if (knowledgeBase) return knowledgeBase;

    var response = await fetch(KNOWLEDGE_BASE_URL, {
      method: 'GET',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Knowledge base could not be loaded.');
    }

    knowledgeBase = await response.json();

    return knowledgeBase;
  }

  /* =========================================================
     MATCHING
     ========================================================= */

  function scoreEntry(query, entry) {
    var normalizedQuery = normalize(query);
    var queryTokens = getTokens(query);
    var score = 0;

    var keywords = Array.isArray(entry.keywords)
      ? entry.keywords
      : [];

    var questions = Array.isArray(entry.questions)
      ? entry.questions
      : [];

    keywords.forEach(function (keyword) {
      var k = normalize(keyword);

      if (!k) return;

      if (normalizedQuery === k) {
        score += 10;
      } else if (normalizedQuery.indexOf(k) !== -1) {
        score += 6;
      } else {
        var keywordTokens = getTokens(k);

        keywordTokens.forEach(function (token) {
          if (queryTokens.indexOf(token) !== -1) {
            score += 2;
          }
        });
      }
    });

    questions.forEach(function (question) {
      var q = normalize(question);

      if (!q) return;

      if (normalizedQuery === q) {
        score += 12;
      } else if (
        normalizedQuery.indexOf(q) !== -1 ||
        q.indexOf(normalizedQuery) !== -1
      ) {
        score += 8;
      }
    });

    /*
     * Strong intent shortcuts.
     * These prevent generic words such as "services" or
     * "consultant" from overpowering the intended entry.
     */
    if (
      normalizedQuery.indexOf('our services') !== -1 ||
      normalizedQuery.indexOf('core services') !== -1 ||
      normalizedQuery.indexOf('show me your services') !== -1
    ) {
      if (entry.id === 'our-services') score += 20;
    }

    if (
      normalizedQuery.indexOf('talk to a consultant') !== -1 ||
      normalizedQuery.indexOf('speak to a consultant') !== -1 ||
      normalizedQuery.indexOf(
        'want to speak to a consultant'
      ) !== -1 ||
      normalizedQuery.indexOf('book consultation') !== -1 ||
      normalizedQuery.indexOf('sme consultation') !== -1
    ) {
      if (
        entry.id === 'contact' ||
        entry.id === 'sme-consultation'
      ) {
        score += entry.id === 'contact' ? 20 : 5;
      }
    }

    return score;
  }

  function findMatches(query) {
    if (
      !knowledgeBase ||
      !Array.isArray(knowledgeBase.knowledge)
    ) {
      return [];
    }

    var minimum =
      knowledgeBase.settings &&
      Number(
        knowledgeBase.settings.minimum_match_score
      );

    if (!Number.isFinite(minimum)) {
      minimum = 4;
    }

    var scored = knowledgeBase.knowledge
      .map(function (entry) {
        return {
          entry: entry,
          score: scoreEntry(query, entry)
        };
      })
      .filter(function (item) {
        return item.score >= minimum;
      })
      .sort(function (a, b) {
        return b.score - a.score;
      });

    if (!scored.length) {
      return [];
    }

    var topScore = scored[0].score;

    /*
     * Include similarly relevant entries so broad product
     * questions can show a horizontal product carousel.
     */
    var selected = scored.filter(function (item, index) {
      if (index === 0) return true;

      var difference = topScore - item.score;

      return (
        difference <= 5 &&
        item.entry.category ===
          scored[0].entry.category
      );
    });

    return selected.slice(
      0,
      MAX_PRODUCT_CARDS + 1
    );
  }

  /* =========================================================
     MESSAGE UI
     ========================================================= */

  function addUserMessage(text) {
    var wrapper =
      document.createElement('div');

    wrapper.className =
      'aivora-ai-chat__message ' +
      'aivora-ai-chat__message--user';

    wrapper.innerHTML =
      '<div class="aivora-ai-chat__bubble">' +
      escapeHtml(text) +
      '</div>';

    messages.appendChild(wrapper);

    scrollToBottom();
  }

  function createBotMessage(answer) {
    var wrapper =
      document.createElement('div');

    wrapper.className =
      'aivora-ai-chat__message ' +
      'aivora-ai-chat__message--bot';

    var bubble =
      document.createElement('div');

    bubble.className =
      'aivora-ai-chat__bubble';

    bubble.innerHTML =
      formatText(answer || '');

    wrapper.appendChild(bubble);
    messages.appendChild(wrapper);

    return wrapper;
  }

  function showTyping() {
    if (!typingIndicator) return;

    typingIndicator.style.display = 'block';

    scrollToBottom();
  }

  function hideTyping() {
    if (!typingIndicator) return;

    typingIndicator.style.display = 'none';
  }

  /* =========================================================
     PRODUCT CARD DATA
     ========================================================= */

  function getProductHandle(entry) {
    if (entry.product_handle) {
      return entry.product_handle;
    }

    var links =
      Array.isArray(entry.links)
        ? entry.links
        : [];

    for (var i = 0; i < links.length; i += 1) {
      var url = links[i].url || '';

      if (url.indexOf('/products/') === 0) {
        return url
          .split('/products/')[1]
          .split('/')[0]
          .replace(/\.js$/i, '');
      }
    }

    return null;
  }

  function getEntryProductUrl(entry) {
    var links =
      Array.isArray(entry.links)
        ? entry.links
        : [];

    for (var i = 0; i < links.length; i += 1) {
      if (
        links[i].url &&
        links[i].url.indexOf('/products/') === 0
      ) {
        return links[i].url;
      }
    }

    var handle =
      getProductHandle(entry);

    return handle
      ? '/products/' + handle
      : null;
  }

  async function fetchShopifyProduct(handle) {
    if (!handle) return null;

    var endpoint =
      '/products/' +
      encodeURIComponent(handle) +
      '.js';

    var response = await fetch(endpoint, {
      method: 'GET',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(
        'Product data unavailable.'
      );
    }

    return response.json();
  }

  function formatMoneyFromShopify(product) {
    if (!product) return '';

    if (product.price != null) {
      var rawPrice =
        Number(product.price);

      if (Number.isFinite(rawPrice)) {
        return new Intl.NumberFormat(
          document.documentElement.lang ||
            'en-US',
          {
            style: 'currency',
            currency: 'USD'
          }
        ).format(rawPrice / 100);
      }
    }

    if (product.price_min != null) {
      var min =
        Number(product.price_min);

      if (Number.isFinite(min)) {
        return new Intl.NumberFormat(
          document.documentElement.lang ||
            'en-US',
          {
            style: 'currency',
            currency: 'USD'
          }
        ).format(min / 100);
      }
    }

    return '';
  }

  function getProductImage(product) {
    if (!product) return '';

    if (product.featured_image) {
      return product.featured_image;
    }

    if (
      Array.isArray(product.images) &&
      product.images.length
    ) {
      return product.images[0];
    }

    return '';
  }

  /* =========================================================
     PRODUCT CARD RENDERING
     ========================================================= */

  async function renderProductCards(entries) {
    var productEntries =
      entries.filter(function (entry) {
        return (
          entry &&
          (
            entry.category === 'Products' ||
            entry.content_type === 'product'
          )
        );
      });

    if (!productEntries.length) {
      return;
    }

    var grid =
      document.createElement('div');

    grid.className =
      'aivora-ai-chat__product-grid';

    messages.appendChild(grid);

    var results =
      await Promise.all(
        productEntries
          .slice(0, MAX_PRODUCT_CARDS)
          .map(async function (entry) {
            var handle =
              getProductHandle(entry);

            try {
              var product =
                await fetchShopifyProduct(
                  handle
                );

              return {
                entry: entry,
                product: product
              };
            } catch (error) {
              return {
                entry: entry,
                product: null
              };
            }
          })
      );

    results.forEach(function (result) {
      var entry = result.entry;
      var product = result.product;

      var productUrl =
        (product && product.url) ||
        getEntryProductUrl(entry);

      var linkLabel =
        Array.isArray(entry.links) &&
        entry.links[0] &&
        entry.links[0].label
          ? entry.links[0].label
          : 'View Product';

      var title =
        (product && product.title) ||
        linkLabel
          .replace(/^View\s+/i, '')
          .replace(/^View\s+/i, '');

      var image =
        getProductImage(product);

      var price =
        formatMoneyFromShopify(product);

      var card =
        document.createElement('button');

      card.type = 'button';

      card.className =
        'aivora-ai-chat__product-card';

      card.setAttribute(
        'aria-label',
        'Open ' + title
      );

      var imageWrap =
        document.createElement('div');

      imageWrap.className =
        'aivora-ai-chat__product-image-wrap';

      if (image) {
        var img =
          document.createElement('img');

        img.className =
          'aivora-ai-chat__product-image';

        img.src = image;
        img.alt = title;
        img.loading = 'lazy';

        imageWrap.appendChild(img);
      } else {
        var placeholder =
          document.createElement('div');

        placeholder.className =
          'aivora-ai-chat__product-image-placeholder';

        placeholder.textContent =
          'AIVORA CyberSol';

        imageWrap.appendChild(
          placeholder
        );
      }

      var body =
        document.createElement('div');

      body.className =
        'aivora-ai-chat__product-body';

      var titleEl =
        document.createElement('div');

      titleEl.className =
        'aivora-ai-chat__product-title';

      titleEl.textContent =
        title;

      body.appendChild(titleEl);

      if (price) {
        var priceEl =
          document.createElement('div');

        priceEl.className =
          'aivora-ai-chat__product-price';

        priceEl.textContent =
          price;

        body.appendChild(priceEl);
      }

      var linkEl =
        document.createElement('div');

      linkEl.className =
        'aivora-ai-chat__product-link';

      linkEl.textContent =
        'View product';

      body.appendChild(linkEl);

      card.appendChild(imageWrap);
      card.appendChild(body);

      card.addEventListener(
        'click',
        function () {
          openUrl(productUrl);
        }
      );

      grid.appendChild(card);
    });

    if (!grid.children.length) {
      grid.remove();
    }

    scrollToBottom();
  }

  /* =========================================================
     NORMAL LINK / CTA BUTTONS
     ========================================================= */

  function renderLinks(entries) {
    var allLinks = [];

    entries.forEach(function (entry) {
      var links =
        Array.isArray(entry.links)
          ? entry.links
          : [];

      links.forEach(function (link) {
        if (!link || !link.url) return;

        var isProduct =
          link.type === 'product' ||
          link.show_product_card === true ||
          link.url.indexOf('/products/') === 0;

        /*
         * Product links are represented by product cards.
         * Do not duplicate them as plain buttons.
         */
        if (isProduct) return;

        allLinks.push({
          entry: entry,
          link: link
        });
      });
    });

    if (!allLinks.length) return;

    var container =
      document.createElement('div');

    container.className =
      'aivora-ai-chat__response-links';

    allLinks.forEach(function (item) {
      var link = item.link;

      var isExternal =
        /^https?:\/\//i.test(
          link.url
        );

      var isCta =
        link.type === 'cta' ||
        item.entry.content_type ===
          'contact';

      var button =
        document.createElement('button');

      button.type = 'button';

      button.className =
        isCta
          ? 'aivora-ai-chat__response-cta'
          : 'aivora-ai-chat__response-link';

      button.textContent =
        link.label || 'Open';

      button.addEventListener(
        'click',
        function () {
          if (isExternal) {
            openExternalUrl(
              link.url
            );
          } else {
            openUrl(link.url);
          }
        }
      );

      container.appendChild(button);
    });

    messages.appendChild(container);

    scrollToBottom();
  }

  /* =========================================================
     RESPONSE
     ========================================================= */

  async function answerQuery(query) {
    showTyping();

    try {
      var kb =
        await loadKnowledgeBase();

      var matches =
        findMatches(query);

      hideTyping();

      if (!matches.length) {
        var fallback =
          kb.fallback ||
          {};

        createBotMessage(
          fallback.message ||
          'Sorry, I could not find that in the AIVORA CyberSol knowledge base.'
        );

        if (
          fallback.contact_label &&
          fallback.contact_url
        ) {
          renderLinks([
            {
              links: [
                {
                  label:
                    fallback.contact_label,
                  url:
                    fallback.contact_url,
                  type: 'page'
                }
              ]
            }
          ]);
        }

        return;
      }

      /*
       * The strongest matching answer is the main answer.
       * This keeps the conversation natural while allowing
       * additional matching products to appear as cards.
       */
      var primary =
        matches[0].entry;

      createBotMessage(
        primary.answer || ''
      );

      renderLinks(
        matches.map(function (item) {
          return item.entry;
        })
      );

      await renderProductCards(
        matches.map(function (item) {
          return item.entry;
        })
      );

    } catch (error) {
      hideTyping();

      createBotMessage(
        'I’m having trouble loading the AIVORA CyberSol knowledge base right now. Please try again.'
      );

      console.error(
        'AIVORA CyberSol chatbot error:',
        error
      );
    }
  }

  /* =========================================================
     QUICK BUTTONS
     ========================================================= */

  quickButtons.forEach(function (button) {
    button.addEventListener(
      'click',
      function () {
        var message =
          button.getAttribute(
            'data-chat-message'
          );

        if (!message) return;

        openChat();

        addUserMessage(message);

        answerQuery(message);
      }
    );
  });

  /* =========================================================
     SEND MESSAGE
     ========================================================= */

  if (chatForm) {
    chatForm.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();

        var message =
          chatInput.value.trim();

        if (!message) return;

        addUserMessage(message);

        chatInput.value = '';
        chatInput.style.height =
          'auto';

        sendButton.disabled =
          true;

        answerQuery(message).finally(
          function () {
            sendButton.disabled =
              false;
          }
        );
      }
    );
  }

  /* =========================================================
     INPUT BEHAVIOUR
     ========================================================= */

  if (chatInput) {
    chatInput.addEventListener(
      'input',
      function () {
        chatInput.style.height =
          'auto';

        chatInput.style.height =
          Math.min(
            chatInput.scrollHeight,
            120
          ) + 'px';

        if (sendButton) {
          sendButton.disabled =
            !chatInput.value.trim();
        }
      }
    );

    chatInput.addEventListener(
      'keydown',
      function (event) {
        if (
          event.key === 'Enter' &&
          !event.shiftKey
        ) {
          event.preventDefault();

          if (
            chatInput.value.trim() &&
            chatForm
          ) {
            chatForm.requestSubmit();
          }
        }
      }
    );
  }

  /* =========================================================
     INITIAL STATE
     ========================================================= */

  if (
    sendButton &&
    chatInput
  ) {
    sendButton.disabled =
      !chatInput.value.trim();
  }

})();